var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgQuestions = function SvgQuestions(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 17.083a7.083 7.083 0 1 0 0-14.166 7.083 7.083 0 0 0 0 14.166Zm0 1.25a8.333 8.333 0 1 0 0-16.666 8.333 8.333 0 0 0 0 16.666Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.334 7.917c0-.55.208-.92.495-1.164.3-.255.724-.399 1.171-.399.448 0 .87.144 1.171.399.288.243.496.615.496 1.164 0 .377-.107.602-.25.776-.164.201-.395.36-.722.579l-.028.018c-.294.196-.674.45-.968.809-.326.399-.532.903-.532 1.568a.625.625 0 0 0 1.25 0c0-.378.107-.602.25-.776.164-.202.395-.361.722-.58l.028-.018c.294-.196.674-.449.968-.809.326-.398.532-.903.532-1.567 0-.91-.364-1.632-.937-2.118-.559-.474-1.281-.695-1.98-.695-.698 0-1.42.221-1.98.695-.572.486-.936 1.208-.936 2.118a.625.625 0 1 0 1.25 0ZM9.792 15a.833.833 0 1 0 0-1.667.833.833 0 0 0 0 1.667Z"
  })));
};
export default SvgQuestions;